<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title>Alterar senha</h1>
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <form [formGroup]="formAtualizarSenha">
      <mat-form-field appearance="outline" class="password-input full-width">
        <mat-label>Nova Senha</mat-label>
        <input matInput placeholder="Nova senha" name="password" formControlName="newPassword"
          [type]="hide ? 'password' : 'text'" required #inputPassword />
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide">
          <mat-icon>
            {{ hide ? "visibility_off" : "visibility" }}
          </mat-icon>
        </button>
      </mat-form-field>
      <app-password-meter [password]="newPassword" (buttonPassword)="passwordValid($event)"></app-password-meter>
      <mat-form-field appearance="outline" class="password-input full-width">
        <mat-label>Confirmar Senha</mat-label>
        <input matInput placeholder="Confirmar Senha" name="confirmPassword" formControlName="newConfirmPassword"
          [type]="hide ? 'password' : 'text'" required #inputPassword />
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide">
          <mat-icon>
            {{ hide ? "visibility_off" : "visibility" }}
          </mat-icon>
        </button>
      </mat-form-field>
    </form>
  </div>
  <div class="modal-actions" mat-dialog-actions align="end">
    <button [disabled]="!passwordIsValid || formAtualizarSenha.invalid" (click)="confirmar()" mat-flat-button
      color="primary">Alterar senha</button>
  </div>
</div>